import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    topImage: {
        width: '472px',
        height: '552.18px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        sizing: 'border-box',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        radius: '15px',
        borderRadius: '25px',
        opacity: 0.9,
        margin: '0 auto 0 auto'
    },
    leftGrid: {
        textAlign: 'left'
    },
    motivationalTitle: {
        background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
        lineHeight: 1.4,



        fontWeight: 500,
        fontSize: 'calc(3.125rem + ((1vw - 4.14px) * 0.9107))',
    },
    advisorParent:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap:'wrap',
        maxWidth: '260px',
    },
    advisorsGrid: {
        margin: '5rem auto 12rem auto',
    },
    advisorImg:{
        width: '240px',
        height: '240px',
        borderRadius: '50%',
        objectFit: 'cover',
        overflow: 'hidden',
    },
    advisorName:{
        fontSize: '20px',
        marginTop: '40px',
    },
    advisorBody:{
        fontSize: '14px',  
        marginTop: '20px',
        width: '260px',
        textAlign: 'left',
        minHeight: '200px'
    },
    smallTitle: {

    },
    signupButton: {
        color: 'white',
        background: '#F3923D',
        borderRadius: '32.83px',
        marginTop: 60,
        marginRight: 25,
        padding: '12px 30px',
        fontSize: '16px',

    },
    loginButton: {
        color: '#F3923D',
        marginTop: 60,
        background: '#FFFFFF',
        border: '1px solid #F3923D',
        borderRadius: '32.83px',
        padding: '12px 30px',
        fontSize: '16px',

    },
    topGridContainer: {
        borderRadius: 4,
        marginTop: '5rem',
        padding: '16px',
        fontFamily: 'Noto Sans JP'
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },
    sliderTab: {
        margin: '10rem auto 12rem auto',
    },
    advisorAlt: {
        width: '240px',
        height: '240px',
        borderRadius: '120px',
        backgroundColor: '#C4C4C4',
        margin: '10px auto',
    },
    sponsorDiv: {
        width: 'auto',
        align: 'center',
        boxSizing: 'border-box',
        borderRadius: '32.83px',
        background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
        border: '2px solid white',
        padding: '50px 30px',
        margin: '50px 0',
    },
    sponsorLogos: {
        height: 120,
        maxWidth: 300,
        objectFit: 'contain',
    }
}));